import EventObserver from './classes/EventObserver';

export const catalogFilterChangeObserver = new EventObserver();
export const searchBadgeDeleteObserver = new EventObserver();
export const playbackObserver = new EventObserver();
export const trackListCreateObserver = new EventObserver();
export const catalogRenderObserver = new EventObserver();

